<template>
  <div class="radial-summary-item" ref="progressChartMain">
    <div class="radial-summary-item__top">
      <div class="radial-summary-item__radial">
        <VueCircle
          ref="vueCircle"
          :progress="chartProgress"
          :size="120"
          line-cap="round"
          :fill="chartFill"
          empty-fill="#F8F6F4"
          :animation-start-value="0.0"
          :start-angle="-1.57"
          insert-mode="append"
          :thickness="10"
          :show-percent="false" />
        <div class="radial-summary-item__radial-count"><span>{{ credits }}</span><span> / </span><span>{{ courseCreditsMax }}</span></div>
      </div>
      <div class="radial-summary-item__key">
        <span class="radial-summary-item__key-label planned" v-if="courseCreditsMax - credits > 0">Units selected: {{ credits }}
          points<br /> (excluding duplicates)</span>
        <span class="radial-summary-item__key-label remaining"
          v-if="credits < courseCreditsMax">{{ courseCreditsMax - credits }} more points needed</span>
        <span class="radial-summary-item__key-label completed" v-if="credits == courseCreditsMax">All units selected!</span>
        <span class="radial-summary-item__key-label danger" v-if="credits > courseCreditsMax">Too many units selected!</span>
      </div>
    </div>
    <div class="radial-summary-item__title">Total unit points for course</div>
  </div>
</template>

<script>
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    courseCreditsMax: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      fill: { color: '#2372A7' },
      fillWarning: { color: '#99600B' },
      fillDanger: { color: '#62090E' },
      fillSuccess: { color: '#317817' },
      isMounted: false
    }
  },
  methods: {},
  computed: {
    ...mapGetters({
      totalCredits: 'units/getTotalCredits'
    }),
    chartFill() {
      // Turns selected unit points to a % for radial charts
      let fill = this.fill

      //change the color based on the credits.
      if (this.isMounted) {
        if (this.credits > this.maxCredits) fill = this.fillDanger
        else if (this.credits == this.maxCredits) fill = this.fillSuccess
        this.$refs?.vueCircle?.updateFill(fill)
      }

      return fill
    },
    chartProgress() {
      // Turns selected unit points to a % for radial charts
      let progress = (100 / this.maxCredits) * this.credits
      if (this.isMounted) this.$refs?.vueCircle?.updateProgress(progress)
      return progress
    },
    credits() {
      //return the new credit tally
      return this.totalCredits('root', false)
    },
    maxCredits() {
      return this.courseCreditsMax
    },
    remainingCreditsForLocation() {
      return this.maxCredits - this.credits
    }
  },
  mounted() {
    this.isMounted = true
  },
  components: { VueCircle }
}
</script>
